import { ROOT_URL as INCIDENTS_ROOT_URL } from 'xm-constants/incidentManagement';

const FETCH_INCIDENTS_BY_REQUEST_ID = 'FETCH_INCIDENTS_BY_REQUEST_ID';
export const FETCH_INCIDENTS_BY_REQUEST_ID_START = `${FETCH_INCIDENTS_BY_REQUEST_ID}_START`;
export const FETCH_INCIDENTS_BY_REQUEST_ID_SUCCESS = `${FETCH_INCIDENTS_BY_REQUEST_ID}_SUCCESS`;

const FETCH_EVENTS_BY_REQUEST_ID = 'FETCH_EVENTS_BY_REQUEST_ID';
export const FETCH_EVENTS_BY_REQUEST_ID_START = `${FETCH_EVENTS_BY_REQUEST_ID}_START`;
export const FETCH_EVENTS_BY_REQUEST_ID_SUCCESS = `${FETCH_EVENTS_BY_REQUEST_ID}_SUCCESS`;

export const FETCH_BY_REQUEST_ID_RESET = 'FETCH_BY_REQUEST_ID_RESET';

export function fetchEvents(requestId) {
  return {
    type: FETCH_EVENTS_BY_REQUEST_ID,
    meta: {
      xmApi: true,
      uri: '/webapi/xm/1/events',
      method: 'get',
      params: {
        requestId,
      },
    },
  };
}

export function fetchIncidents(requestId) {
  return {
    type: FETCH_INCIDENTS_BY_REQUEST_ID,
    meta: {
      xmApi: true,
      uri: INCIDENTS_ROOT_URL,
      method: 'get',
      params: {
        requestId,
      },
    },
  };
}

export function reset() {
  return {
    type: FETCH_BY_REQUEST_ID_RESET,
  };
}
